import React from 'react';
import { TextareaNesting } from '../../common/Inputs/Input';
import { useTranslate } from '../../../lib'

export default function ClosingMessage({ showClosing, closing_mesageRef }) {
  const { t } = useTranslate();
  if (!showClosing) return null;

  return (
    <div className="d-flex flex-row w-100">
      <TextareaNesting
        containerClass="mr-1"
        style={{ flexGrow: '1', minWidth: 450 }}
        ref={closing_mesageRef}
        id="closing_mesage"
        type="text"
        row={2}
        title={t('menu.genai.closingCallMessage')}
      />
    </div>
  );
}
